module.exports = __webpack_public_path__ + "img/logoJS.0ea29acb.svg";